export default [
  {
    title: 'Remote',
    icon: 'SmartphoneIcon',
    route: 'remote'
  },
]
